import React, { createContext, useCallback, useContext, useState } from 'react';
import { useColocApi } from '@/hooks/use-coloc-api';
import { VacancyMaintenanceListSortType } from '@/types/admin';

type VacancyMaintenanceFiltersContextType = {
  selectedVacancyHouse: { id: string; name: string } | undefined;
  setSelectedVacancyHouse: (house: { id: string; name: string } | undefined) => void;
  selectedVacancyStatus: string;
  setSelectedVacancyStatus: (status: string) => void;
  housesQuery: string;
  setHousesQuery: (query: string) => void;
};

const VacancyMaintenanceFiltersContext = createContext<
  VacancyMaintenanceFiltersContextType | undefined
>(undefined);

export const useVacancyMaintenanceFiltersContext = () => {
  const context = useContext(VacancyMaintenanceFiltersContext);
  if (!context) {
    throw new Error(
      'useVacancyMaintenanceFiltersContext must be used within VacancyMaintenanceFiltersProvider'
    );
  }
  return context;
};

export const VacancyMaintenanceFiltersProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedVacancyHouse, setSelectedVacancyHouse] = useState<
    { id: string; name: string } | undefined
  >(undefined);
  const [selectedVacancyStatus, setSelectedVacancyStatus] = useState<string>('');
  const [housesQuery, setHousesQuery] = useState('');
  const { setColumnToSort } = useColocApi<VacancyMaintenanceListSortType>()!;

  return (
    <VacancyMaintenanceFiltersContext.Provider
      value={{
        selectedVacancyHouse,
        setSelectedVacancyHouse,
        selectedVacancyStatus,
        setSelectedVacancyStatus,
        housesQuery,
        setHousesQuery,
      }}
    >
      {children}
    </VacancyMaintenanceFiltersContext.Provider>
  );
};
